import type { AppState } from 'state/model';
import type { SaveState } from '../clientWorkspaceModel';

export function getSaveState(state: AppState): SaveState {
  return state.clientWorkspace.saveState;
}
